export default __webpack_public_path__ + "static/media/dpworld.108a5a65.png";